"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDnd = require("react-dnd");
var _Item = _interopRequireDefault(require("../Item"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Target = function Target(props) {
  var targetId = props.targetId,
    items = props.items,
    itemProps = props.itemProps,
    placeholder = props.placeholder,
    setPlaceholder = props.setPlaceholder,
    moveItem = props.moveItem,
    className = props.className;
  var _useDrop = (0, _reactDnd.useDrop)({
      accept: 'item',
      canDrop: function canDrop(item, monitor) {
        return item.group !== 'user' || targetId !== 'source';
      },
      drop: function drop(item) {
        moveItem(item, placeholder.targetId, placeholder.indexAfter + 1);
      },
      collect: function collect(monitor) {
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop()
        };
      },
      hover: function hover(draggedItem, monitor) {
        if (placeholder.targetId !== targetId) {
          setPlaceholder({
            targetId: targetId,
            indexAfter: items.length - 1
          });
        }
      }
    }),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    _useDrop2$ = _useDrop2[0],
    isOver = _useDrop2$.isOver,
    canDrop = _useDrop2$.canDrop,
    drop = _useDrop2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: drop,
    className: className,
    "data-source-block": true,
    style: targetId !== 'source' && isOver && canDrop ? {
      background: 'rgba(51, 122, 183, 0.1)'
    } : {}
  }, placeholder && placeholder.show && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].placeholder,
    style: {
      paddingTop: canDrop && placeholder.targetId === targetId && placeholder.indexAfter === -1 ? "calc(".concat(placeholder.height, "px + 0.5em)") : 0
    }
  }), items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "".concat(item.type, "_").concat(item.id)
    }, /*#__PURE__*/_react["default"].createElement(_Item["default"], _extends({
      index: index,
      targetId: targetId,
      item: item,
      placeholder: placeholder,
      setPlaceholder: setPlaceholder
    }, itemProps)), placeholder && placeholder.show && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].placeholder,
      style: {
        paddingTop: canDrop && placeholder.targetId === targetId && placeholder.indexAfter === index ? "calc(".concat(placeholder.height, "px + 0.5em)") : 0
      }
    }));
  }));
};
Target.propTypes = {
  targetId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  items: _propTypes["default"].array,
  itemProps: _propTypes["default"].object,
  placeholder: _propTypes["default"].object,
  setPlaceholder: _propTypes["default"].func,
  moveItem: _propTypes["default"].func,
  className: _propTypes["default"].string
};
Target.defaultProps = {
  className: ''
};
var _default = exports["default"] = Target;